import { PrizmLanguageInputLayoutDateRelative } from '../../interfaces';

export const PRIZM_ENGLISH_INPUT_LAYOUT_DATE_RELATIVE: PrizmLanguageInputLayoutDateRelative = {
  inputLayoutDateRelative: {
    wrongFormat: 'Incorrect data format',
  },
};
